<template>
  <model-form
    ref="modelForm"
    :model="page"
  >
    <div class="q-gutter-sm">
      <div class="row q-gutter-md items-start">
        <model-form-input
          field="title"
          class="col"
          label="Title"
          :rules="[val => !!val || 'Field is required']"
          autofocus
        />
        <model-form-input
          field="slug"
          class="col"
          label="URL Slug"
          readonly
        />
        <model-form-input
          field="startDate"
          class="col"
          label="Start Date"
          :rules="[
            () => !page.startDate || !page.endDate || page.startDate <= page.endDate || 'Date cannot postdate end date',
          ]"
        />
        <model-form-input
          field="endDate"
          class="col"
          label="End Date"
          clearable
          :rules="[
            () => !page.endDate || !page.startDate || page.startDate <= page.endDate || 'Date cannot predate start date',
          ]"
        />
        <q-btn
          label="View Page"
          size="lg"
          outline
          @click="viewPage()"
        >
          <q-tooltip>
            View Page
          </q-tooltip>
        </q-btn>
      </div>
      <section-table
        v-if="page.isRemote"
        :page="page"
        :library-collection="$_.isNil(page.draftParent?.libraryParentId) ? null : libraryPage?.sections"
        @change="$emit('change')"
        @save="reloadPage()"
      />
      <div
        class="row q-col-gutter-sm items-start q-mt-sm q-ml-none"
      >
        <model-form-input
          field="searchEngineSnippet"
          class="col-10"
          input-style="max-height: 80px;"
          label="Search Engine Description"
          type="textarea"
          counter
          hint="Used for search engine description. Truncated by search engines at ~160 characters."
        />
        <model-form-toggle
          field="isVisibleToSearchEngines"
          class="col-2 q-pb-md q-my-auto"
          keep-color
          :color="page.isVisibleToSearchEngines ? 'positive' : 'grey'"
          unchecked-icon="clear"
          checked-icon="check"
          label="Visible to Search Engines"
        />
      </div>
      <div
        class="row items-start"
      >
        <model-form-input
          field="styles"
          class="col"
          label="Custom Styles (CSS)"
          type="textarea"
        >
          <q-tooltip>
            Add Custom Styles (CSS)
          </q-tooltip>
        </model-form-input>
      </div>
    </div>
    <preview-page
      v-if="$admin"
      class="custom-page relative-position"
      :page="page"
    />
  </model-form>
</template>

<script>
import { date } from 'quasar'
import { IsoDate } from 'src/models/model'
import ModelFormInput from 'src/modules/admin/components/ModelForm/components/ModelFormInput'
import ModelFormToggle from 'src/modules/admin/components/ModelForm/components/ModelFormToggle'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import SectionTable from 'src/modules/admin/section/SectionTable'
import PreviewPage from 'src/modules/consumer/pages/PreviewPage'

export default {
  name: 'PageForm',
  components: {
    ModelForm,
    SectionTable,
    PreviewPage,
    ModelFormInput,
    ModelFormToggle
  },
  configuration: ['currentSite'],
  models: {
    page: {
      draftParent: {
        fields: ['id', 'draftId', 'libraryParentId', 'receiveLibraryUpdates', 'libraryChildSiteIds'],
        sections: {
          fields: ['id', 'draftId', 'libraryParentId', 'receiveLibraryUpdates', 'libraryChildSiteIds']
        }
      },
      sections: {
        content: true,
        scopeClass: true,
        libraryParentId: true,
        receiveLibraryUpdates: true,
        libraryChildSiteIds: true
      },
      styles: true,
      transformedStyles: true,
      scopeClass: true,
      searchEngineSnippet: true,
      libraryChildSiteIds: true
    },
    libraryPage: {
      queryName: 'page',
      sections: 'default',
      variables () {
        return {
          id: this.page?.draftParent?.libraryParentId,
          skip: _.isNil(this.page?.draftParent?.libraryParentId)
        }
      }
    }
  },
  emits: ['change'],
  created () {
    _.extend(this, { date, IsoDate })
  },
  methods: {
    show (model, initialData) {
      this.$refs.modelForm.show(model, initialData)
    },
    viewPage () {
      const url = this.currentSite.hostname + '/' + this.page.slug
      window.open(url, '_blank')
    },
    reloadPage () {
      this.page.fetch(true)
    }
  }
}
</script>
